import { useDisclosure } from "@chakra-ui/react";

export const useModal = () => {
  return useDisclosure();
};
